<template>
  <div>
    <div class="shopping_list">
      <div class="shopping_box" @click="todetail(index)" v-for="(item,index) in storeList">
        <div class="shoppingbox_left">
          <img class="shopping_img" :src="item.thumb" />
          <div class="shopping_des">{{item.name}}</div>
        </div>
        <img class="shopping_to" src="/static/xiangyou.png" />
      </div>
    </div>
    <!--    <img src="/static/huailian.png" /> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
         storeList: [], //接口获取商品列表


      }
    },
    created() {
  if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
    },
    mounted() {

    },
    methods: {
      // todetail(e) {
      //   this.$router.push({
      //     path: "/shoppingDetail",
      //     query: {
      //       shoppingDetailId: e
      //     }
      //   })
      // },
      todetail(e) {

        this.$router.push({
          path: '/shoppingDetail',
          query: {
            id:this.storeList[Number(e)].id
          }
        })
      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
            //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code === 0) {
                console.log("商品列表", res)
                this.storeList = res.data
              } else {
                this.$toast({
                  message: res.message
                })
              }
            })
            break
        }
      },
    }
  }
</script>

<style>
  .shopping_list {
    margin: 20px;
  }

  .shopping_box {
    width: 95%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    /* background-image: url(../../../static/aiqiyibanner.png); */
  }

  .shoppingbox_left {
    display: flex;
    align-items: center;
  }

  .shopping_img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin: 10px;
  }

  .shopping_des {}

  .shopping_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/shoppingList.vue